// 首屏动画
var matrix_one = window.innerWidth / 918;
var matrix_three = window.innerWidth / 918;
var matrix_six = window.innerHeight - 506 - 58;
if (window.innerWidth <= 1024) {
  matrix_one = 2.24468
  matrix_three = 2.24468
  matrix_six = 341.6
}

// 苹果适配
if (window.innerHeight <= 1024) {
  matrix_six = 341.6
}
if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
  matrix_six = (window.innerHeight / 2.7) - 58;
}
if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 && innerHeight <= 892) {
  matrix_six = (window.innerHeight / 3.7) - 58;
}
document.addEventListener('DOMContentLoaded', function () {
  let scalingContainer = document.querySelector('.section-hero .scaling-container');
  if (scalingContainer) {
    let scale = matrix_one;
    let skew = matrix_six;
    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
  }
});

window.addEventListener('resize', function () {
  matrix_one = window.innerWidth / 918;
  matrix_three = window.innerWidth / 918;
  var matrix_six = window.innerHeight - 506 - 58

  if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
    matrix_six = (window.innerHeight / 2.7) - 58;
  }

  if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 && innerHeight <= 892) {
    matrix_six = (window.innerHeight / 3.7) - 58;
  }

  if (window.innerWidth <= 1024) {
    matrix_one = 2.24468
    matrix_three = 2.24468
    matrix_six = 341.6
  }
  if (window.innerWidth >= 2048) {
    matrix_six = (window.innerHeight / 2) - 58;
  }

  let scalingContainer = document.querySelector('.section-hero .scaling-container');
  if (scalingContainer) {
    let scale = window.innerWidth / 918;
    if (window.innerWidth <= 1024) {
      scale = 2.24468
    }
    let skew = matrix_six;
    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
  }
});

document.addEventListener('scroll', function () {
  let scalingContainer = document.querySelector('.scaling-container');
  let sectionHero = document.querySelector(".section-hero")
  if (scalingContainer) {
    let videoMedia = document.querySelector('.inline-video-media video');
    let sticky_item_title = document.querySelector('.sticky-item_title');
    let videoFrameStatic = document.querySelector('.inline-video-frame-static');
    let overviewHeroTvShadowColor = document.querySelector('.overview-hero-hero-tv-shadow-color');
    let overviewHeroTvRemote = document.querySelector('.overview-hero-hero-tv-remote');

    let maxScroll = window.innerHeight * 1.75 - window.innerHeight;
    let scrollFraction = (window.scrollY - sectionHero.offsetTop)  / maxScroll;
    let scale = Math.max(0.8, matrix_one - scrollFraction * (matrix_one - 0.8));
    if (window.innerWidth <= 1024) {
      scale = Math.max(0.4, matrix_one - scrollFraction * (matrix_one - 0.4));
    }
    let skew = Math.max(0, matrix_six - scrollFraction * matrix_six);
    let scale_two = Math.max(0.5, 1 - scrollFraction / 2);
    let skew_two = Math.max(-30, 0 - scrollFraction * (matrix_six + 30));
    if (window.innerWidth >= 3840) {
      scale = Math.max(2, matrix_one - scrollFraction * (matrix_one - 2));
      skew = 400;
    }

    scalingContainer.style.transform = `matrix(${scale}, 0, 0, ${scale}, 0, ${skew})`;
    overviewHeroTvRemote.style.transform = `matrix(${scale_two}, 0, 0, ${scale_two}, 0, ${skew_two})`;

    if (overviewHeroTvShadowColor) {
      overviewHeroTvShadowColor.style.opacity = `${0 + scrollFraction}`;
    }

    if (scale < 1.5) {
      if (videoMedia) {
        videoMedia.style.opacity = '0';
        sticky_item_title.style.opacity = '1';
      }
      if (videoFrameStatic) {
        videoFrameStatic.style.opacity = '1';
        overviewHeroTvShadowColor.classList.add('no-blur');

      }
    } else {
      if (videoMedia) {
        videoMedia.style.opacity = '1';
        sticky_item_title.style.opacity = '0';
      }
      if (videoFrameStatic) {
        videoFrameStatic.style.opacity = '0';
        overviewHeroTvShadowColor.classList.remove('no-blur');
      }
    }

    let sectionContent = document.querySelector('.section-content');
    if (sectionContent) {
      let maxScroll = window.innerHeight * 1.75 - window.innerHeight;
      let scrollFraction = (window.scrollY - sectionHero.offsetTop) / maxScroll;
      sectionContent.style.opacity = `${Math.max(1, 0 + scrollFraction / 4)}`;
    }
    // if (scale < 1.1) {
    //   sectionContent.style.opacity = '1';
    // } else {
    //   sectionContent.style.opacity = '1';
    // }
    let headlineHero = document.querySelector('.headline-hero');
    if (headlineHero) {
      if ((window.scrollY - sectionHero.offsetTop) >= 10) {
        headlineHero.style.opacity = '0';
      } else {
        headlineHero.style.opacity = '1';
      }
    }
    let video_container = document.querySelector('.video-container');
    
    if (video_container) {
      if ((window.scrollY - sectionHero.offsetTop) >= 10) {
        video_container.style.filter = 'brightness(1)';
      } else {
        video_container.style.filter = 'brightness(0.6)';
      }
    }
  }
});